import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-emerald-900 text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Column 1 - Logo & Description */}
          <div>
            <img
              src="https://static.readdy.ai/image/65844f2463df199923cac77fa3e2acf8/2d67e6e815ed2c64bf3c6612a1e2e5fe.png"
              alt="SSP SARL"
              className="h-12 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-sm text-gray-300 leading-relaxed">
              SSP SARL est votre partenaire multiservices de confiance pour tous vos besoins professionnels en RDC.
            </p>
          </div>

          {/* Column 2 - Contact */}
          <div>
            <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 mb-4">
              CONTACT
            </h3>
            <div className="space-y-3 text-sm">
              <div className="flex items-start gap-2">
                <i className="ri-map-pin-line text-orange-500 mt-1"></i>
                <span className="text-gray-300">
                  AV. UNGU-NGANDU, N° 18<br />
                  Q/LATIN, C/MANIKA<br />
                  V/KOLWEZI – RDC
                </span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-phone-line text-orange-500"></i>
                <a href="tel:+243998100499" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  +243 99 8100 499
                </a>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-phone-line text-orange-500"></i>
                <a href="tel:+243998141613" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  +243 99 8141 613
                </a>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-mail-line text-orange-500"></i>
                <a href="mailto:info@sspsarl.com" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  info@sspsarl.com
                </a>
              </div>
            </div>
          </div>

          {/* Column 3 - Quick Links */}
          <div>
            <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 mb-4">
              NAVIGATION
            </h3>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-white hover:text-orange-500 transition-colors cursor-pointer">
                Accueil
              </Link>
              <Link to="/services" className="text-white hover:text-orange-500 transition-colors cursor-pointer">
                Services
              </Link>
              <Link to="/about" className="text-white hover:text-orange-500 transition-colors cursor-pointer">
                À propos
              </Link>
              <Link to="/contact" className="text-white hover:text-orange-500 transition-colors cursor-pointer">
                Contact
              </Link>
            </div>
          </div>

          {/* Column 4 - Social Media */}
          <div>
            <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 mb-4">
              SUIVEZ-NOUS
            </h3>
            <div className="flex flex-col gap-3">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-orange-500 transition-colors flex items-center gap-2 cursor-pointer"
              >
                <i className="ri-linkedin-fill"></i>
                LinkedIn
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-orange-500 transition-colors flex items-center gap-2 cursor-pointer"
              >
                <i className="ri-facebook-fill"></i>
                Facebook
              </a>
              <a
                href="https://wa.me/243998100499"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-orange-500 transition-colors flex items-center gap-2 cursor-pointer"
              >
                <i className="ri-whatsapp-fill"></i>
                WhatsApp
              </a>
            </div>
          </div>
        </div>

        {/* Giant Typography */}
        <div className="relative overflow-hidden py-12">
          <div className="text-7xl lg:text-9xl font-bold text-amber-100/10 tracking-tight">
            SSP SARL
          </div>
        </div>
      </div>

      {/* Copyright Bar */}
      <div className="border-t border-emerald-800">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="text-center text-xs text-gray-400">
            © 2025 SSP SARL - Tous droits réservés · by{' '}
            <a
              href="https://logiqsoft.io"
              target="_blank"
              rel="noopener noreferrer"
              className="text-orange-400 hover:text-orange-300 transition-colors cursor-pointer"
            >
              Logiqsoft
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
